import { Modal } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { LegalEntityForm } from '@webapp/platform/legal-entities/components/LegalEntityForm'
import { CREATE_LEGAL_ENTITY_STEPS } from './CreateLegalEntityStep'
import messages from './messages'
import { useCreateLegalEntityFormPresenter } from './useCreateLegalEntityFormPresenter'
import { LegalEntityReview } from '../../views/LegalEntityReview'

export interface ICreateLegalEntityFormPresenterProps {
  onCancel: () => void
  onSuccess?: () => void
}

export const CreateLegalEntityFormPresenter = ({
  onCancel,
  onSuccess,
}: ICreateLegalEntityFormPresenterProps) => {
  const intl = useProcurifyIntl()
  const { state, methods } = useCreateLegalEntityFormPresenter({
    onSuccess,
  })

  const title =
    state.step === CREATE_LEGAL_ENTITY_STEPS.FORM
      ? intl.formatMessage(messages.createModalTitle)
      : state.reviewTitle

  return (
    <>
      <Modal.Header onClose={onCancel}>{title}</Modal.Header>
      <Modal.Content>
        {state.step === CREATE_LEGAL_ENTITY_STEPS.FORM ? (
          <LegalEntityForm
            initialValues={state.formValues}
            initialErrors={state.formErrors}
            onContinue={methods.handleContinue}
            onCancel={onCancel}
            showInboxAddress={state.showInboxAddress}
            domain={state.domain}
            isNameTaken={methods.isNameTaken}
            isExternalIdTaken={methods.isExternalIdTaken}
          />
        ) : (
          <LegalEntityReview
            baseCurrencyName={state.baseCurrencyName}
            externalId={state.formValues.externalId}
            country={state.reviewCountry}
            previewInboxEmailAddress={state.previewInboxEmailAddress}
            isConfirming={state.isConfirming}
            onEdit={methods.handleEdit}
            onConfirm={methods.handleConfirm}
          />
        )}
      </Modal.Content>
    </>
  )
}

CreateLegalEntityFormPresenter.displayName = 'CreateLegalEntityFormPresenter'
